// src/services/actualizacion.js
// ¿Hay una versión nueva de la app? El index.html de cada deploy apunta a un JS con un nombre
// distinto (main.<hash>.js). Si el index.html que hay hoy en el servidor apunta a otro, la app que
// tienes abierta es vieja. Funciones puras: la comparación vive aquí y la red/pantalla, en el componente.

// '<script defer="defer" src="/static/js/main.4f1c2a9b.js"></script>' -> 'main.4f1c2a9b.js'
export function bundleDe(textoOUrl) {
  const m = String(textoOUrl || '').match(/\/static\/js\/(main\.[A-Za-z0-9]+\.js)/);
  return m ? m[1] : null;
}

// true solo si se pudieron leer los dos nombres y son distintos (ante la duda, no se molesta).
export function hayVersionNueva(htmlRemoto, srcActual) {
  const nuevo = bundleDe(htmlRemoto);
  const actual = bundleDe(srcActual);
  return !!nuevo && !!actual && nuevo !== actual;
}

export const CADA_MS = 10 * 60 * 1000; // revisión periódica
